import React, { FunctionComponent } from "react";
import styled from "styled-components/macro";

export const Button = styled.button`
  color: #856404;
  background-color: #ffdb70;
  border-color: #ffc107;

  :hover,
  :focus,
  :active {
    color: #856404 !important;
    background-color: #efcd69 !important;
    border-color: #ffc107 !important;
  }
`;

type RetryButtonProps = {
  retryFunction: () => void;
};

const RetryButton: FunctionComponent<RetryButtonProps> = props => {
  const { retryFunction } = props;

  return (
    <Button className="btn btn-sm btn-warning" onClick={retryFunction}>
      Retry
    </Button>
  );
};

export default RetryButton;
